const currentUrl = window.location.hostname;

export const LOCAL = currentUrl === 'localhost';
export const ENV = LOCAL ? 'dev' : (import.meta.env.PROD ? 'prod' : 'dev');
export const DEBUG = LOCAL || ENV === 'dev';

export const BASE_URL = LOCAL ? "http://localhost:3000" : (DEBUG ? "https://panel-dev.n0tlikethat.dev" : "https://blackbird.n0tlikethat.com");
export const BASE_API = LOCAL ? "https://api.local.n0tlikethat.dev" : (DEBUG ? "https://api.n0tlikethat.dev" : "https://api.n0tlikethat.com");
export const API_URL = (LOCAL || DEBUG) ? "https://api.n0tlikethat.dev" : "https://api.n0tlikethat.com";
export const LOGIN_URL = DEBUG ? "https://login.n0tlikethat.dev" : "https://login.n0tlikethat.com";